import { normalizeFieldDigits } from '../../shared/installationProcess';

export default function StageFields({ fields = [], values = {}, disabled, onChange }) {
  return fields.map((field) => {
    const id = `stage-field-${field.key}`;
    const props = { id, disabled, value: Object.hasOwn(values, field.key) ? values[field.key] ?? '' : '', required: field.required,
      onChange: (e) => onChange(field.key, normalizeFieldDigits(e.target.value)) };
    return <div className="inst-field" key={field.key}>
      <label className="inst-label" htmlFor={id}>{field.label_fa}{field.unit && <> (<bdi dir="auto">{field.unit}</bdi>)</>} · {field.required ? 'اجباری' : 'اختیاری'}</label>
      {field.type === 'choice' ? <select {...props} className="inst-select"><option value="">انتخاب کنید</option>{field.choices.map((c) => <option key={c} value={c}>{c}</option>)}</select>
        : field.type === 'text' ? <textarea {...props} className="inst-textarea" dir="auto" maxLength={200} />
          : <input {...props} className="inst-input" type="text" inputMode={field.type === 'number' ? 'decimal' : 'text'} dir="ltr" maxLength={200} autoComplete="off" />}
    </div>;
  });
}
